import { combineReducers } from 'redux';

import {
  initUserPermissionsRequest,
  initUserPermissionsSuccess,
  initUserPermissionsFail,
  getUserPermissionsRequest,
  getUserPermissionsSuccess,
  getUserPermissionsFail,
  createUserPermissionsRequest,
  createUserPermissionsSuccess,
  createUserPermissionsFail,
  saveUserPermissionsRequest,
  saveUserPermissionsSuccess,
  saveUserPermissionsFail,
  resetCurrentUserPermissions,
  setUserPermissionsListRedirect,
  getUserPermissionsListFail,
  getUserPermissionsListSuccess,
  clearUserPermissionsListByUser,
  clearSelectedUserPermissionsList,
} from '../actions';
import { UserPermissionsAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { UserPermissions } from '../../../../types/items';

type State = Loadable<UserPermissions> & {redirect?: boolean};
type ReducerOf<T extends keyof State> = Reducer<State, UserPermissionsAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getUserPermissionsRequest.type:
    case resetCurrentUserPermissions.type:
    case initUserPermissionsRequest.type:
    case clearUserPermissionsListByUser.type:
    case clearSelectedUserPermissionsList.type:
      return null;

    case getUserPermissionsSuccess.type:
    case saveUserPermissionsSuccess.type:
    case initUserPermissionsSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getUserPermissionsRequest.type:
    case createUserPermissionsRequest.type:
    case saveUserPermissionsRequest.type:
    case initUserPermissionsRequest.type:
      return true;

    case getUserPermissionsSuccess.type:
    case getUserPermissionsFail.type:
    case createUserPermissionsSuccess.type:
    case createUserPermissionsFail.type:
    case saveUserPermissionsSuccess.type:
    case saveUserPermissionsFail.type:
    case initUserPermissionsSuccess.type:
    case initUserPermissionsFail.type:
      return false;

    default:
      return state;
  }
};

const redirect: ReducerOf<'redirect'> = (state = false, action) => {
  switch (action.type) {
    case setUserPermissionsListRedirect.type:
      return action.payload;

    case getUserPermissionsListSuccess.type:
    case getUserPermissionsListFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<State>({
  data,
  loading,
  redirect,
});
